import { Injectable } from "@angular/core";
import { SingletonConfirmationModalComponent } from "./singleton-confirmation-modal.component";

@Injectable({ providedIn: 'root' })
export class ConfirmationModalService {
    public confirmationModalComponent: SingletonConfirmationModalComponent;
    constructor() { }
    confirm(
        message: string,
        description: string = '',
        dismissButtonLabel: string = 'Cancel',
        closeButtonLabel = 'Confirm',
        isWarning = false,
        size = 'sm'
    ): Promise<boolean>{
        this.confirmationModalComponent.modalConfig = {
            modalTitle: message,
            modalDesc: description,
            dismissButtonLabel: dismissButtonLabel,
            closeButtonLabel: closeButtonLabel,
            isWarning,
            onDismiss: () => {
                return false;
            },
            onClose: () => {
                return true;
            }
        };

        if (size === 'sm') return this.confirmationModalComponent.open();
        return this.confirmationModalComponent.openMd();
    }  
}
